<template>
  <div>
    <!-- 重新生成纳品计划 -->
    <el-dialog :title="$t('message.reGenerateInboundPlan')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="720px" center>
      <div class="content">
        <p style="margin-bottom: 30px;font-size: 16px;">当前纳品计划异常，无法下载配送标，是否重新生成新的纳品计划并上传装箱信息？</p>
        <p>注意事项：</p>
        <p>
          1.此操作会根据当前配送单内的实际纳品数生成新的纳品计划,数量变动请及时告知客户。<br>
          2.生成纳品计划耗时较长，请耐心等待。<br>
          3.生成纳品计划后需要客户手动下裁配送标。<br>
          4.并单的配送单 不支持此操作
        </p>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 重新生成 -->
        <el-button type="primary" @click="reGenerateInboundPlan">{{
          $t("message.reGenerate")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 重新生成成功 -->
    <el-dialog :title="$t('message.reGenerateSuccess')" :close-on-click-modal="false"
      :visible.sync="reGenerateSuccessDialogVisible" width="720px" center>
      <div class="content">
        <p>
          纳品计划名:{{ response.plan_name }} <br>
          纳品计划链接:{{ response.link }} <br>
          SKU数:{{ response.sku_num }} <br>
          商品数:{{ response.product_num }} <br>
          箱数:{{ response.box_num }} <br>
          确认数据无误后，将纳品计划链接发给客户确认并手动下载配送标。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--关闭 -->
        <el-button @click="reGenerateSuccessDialogVisible = false" type="primary">{{
          $t("message.closure")
        }}</el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    porder_sn: { type: String },
  },
  data() {
    return {
      dialogVisible: false,//重新生成纳品计划弹窗
      reGenerateSuccessDialogVisible: false,//重新生成成功弹窗
      userRoleStatus: localStorage.getItem("japanUserRoleStatus"),
      response: {},//重新生成纳品计划返回数据
    };
  },
  created() {
  },
  methods: {

    // 保存
    reGenerateInboundPlan() {
      let datas = {
        porder_sn: this.porder_sn,
      };

      this.$api.porderApi.inboundPlanResetV2(datas).then((res) => {
        this.dialogVisible = false;
        if (!res.success) {
          this.showGenerateFailAlert(res.msg);
          return;
        }
        this.$message.success(res.msg);
        this.reGenerateSuccessDialogVisible = true;
        this.response = res.data;
        this.$parent.tableData.find(item => item.porder_sn == this.porder_sn).plan_reset = false
        this.$forceUpdate()
      }).catch((err) => {
        this.dialogVisible = false;
        this.showGenerateFailAlert(err && err.msg ? err.msg : '');
      });
    },
    // 重新生成纳品计划失败时统一弹窗提醒，覆盖接口返回失败和请求异常两种情况。
    showGenerateFailAlert(message) {
      this.$alert(message || '纳品计划生成失败，请提交工单处理', '生成失败', {
        confirmButtonText: '确定',
        center: true,
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 20px;

  p {

    line-height: 30px;
  }
}
</style>
